import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import ConversationList from './Conversation.list'
import ConversationShow from './Conversation.show'

const resource = {
  list: ConversationList,
  show: ConversationShow,
  icon: SupportAgentIcon,
}

export default resource
